import Api from 'Helpers/api';

const Squarespace = {
	syncOrders: async () => {
		try {
			const response = await Api.call('get', '/squarespace/orders');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	getUniqueOrder: async () => {
		try {
			const response = await Api.call('get', '/squarespace/order');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	sentOrder: async (params) => {
		try {
			const response = await Api.call('post', '/squarespace/sentorder', params);
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return { error: err };
		}
	}
};

export default Squarespace;
